import { render } from "./PageHeader.vue?vue&type=template&id=6078a1e6"
import script from "./PageHeader.vue?vue&type=script&lang=js"
export * from "./PageHeader.vue?vue&type=script&lang=js"

import "./PageHeader.vue?vue&type=style&index=0&id=6078a1e6&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Sub4Turismo\\FrontSite\\CodigoVueSub4\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__